import api from '../api/api';

export const purchaseInvoicesService = {
  async list() {
    const res = await api.get('/purchase-invoices');
    return res.data;
  },

  async create(payload) {
    const res = await api.post('/purchase-invoices', payload);
    return res.data;
  },

  async update(id, payload) {
    const res = await api.put(`/purchase-invoices/${id}`, payload);
    return res.data;
  },

  async remove(id) {
    const res = await api.delete(`/purchase-invoices/${id}`);
    return res.data;
  },

  // -------------------- Attachments --------------------
  async uploadAttachment(id, file) {
    const formData = new FormData();
    formData.append('file', file);

    const res = await api.post(`/purchase-invoices/${id}/attachment`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    return res.data;
  },

  async deleteAttachment(id) {
    const res = await api.delete(`/purchase-invoices/${id}/attachment`);
    return res.data;
  },

  async getAttachmentBlob(id) {
    const res = await api.get(`/purchase-invoices/${id}/attachment`, {
      responseType: 'blob', 
    });
    return res;
  },

  getAttachmentUrl(id) {
    const baseURL = api.defaults.baseURL || '';
    return `${baseURL}/purchase-invoices/${id}/attachment`;
  },

  // -------------------- OCR --------------------
  async processOcr(file) {
    const formData = new FormData();
    formData.append('file', file);

    const res = await api.post('/purchase-invoices/ocr', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    return res.data;
  },

  async processOcrAuto(file) {
    const formData = new FormData();
    formData.append('file', file);

    const res = await api.post('/purchase-invoices/ocr-auto', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    return res.data;
  },

  // ✅ AJOUTER CETTE MÉTHODE ICI (À LA FIN)
  async importExcel(file) {
    const formData = new FormData();
    formData.append('file', file);

    const workspaceId = localStorage.getItem('activeWorkspaceId');

    const res = await api.post('/purchase-invoices/import-excel', formData, {
      headers: { 
        'Content-Type': 'multipart/form-data',
        'x-workspace-id': workspaceId // On envoie l'ID du dossier actif
      },
    });

    return res.data;
  },
};